import Model from './Model'
import Relationship from './Relationship'
import {ApiOffsetResponse} from 'modules/reports/types/ApiOffset'

type ResponseStructure<DataT, MetaT> = {
  data: DataT
  relationships?: {[key: string]: Model[]}
} & ApiOffsetResponse &
  MetaT

export default class Response<DataT, MetaT = {}> {
  response: ResponseStructure<DataT, MetaT>
  data: DataT

  constructor(response: ResponseStructure<DataT, MetaT>) {
    this.response = response
    this.data = this.response.data

    const {relationships} = this.response
    if (relationships) Relationship.processAll(relationships)
  }

  get total() {
    return this.response.total_records
  }
}
